


import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import firebase from "../../firebase";
import '../../style/PlayscreenParticipant.css';
import axios from "axios";
import NoSleep from "nosleep.js";
// Import alphabet utilities
import { getAlphabetForLanguage, normalizeCharacter, detectLanguageFromWord, isCrowdMode } from "../../utils/alphabetUtils";

export default function PlayScreenParticipant({ onNavigate, code: propCode }) {
    const { code: urlCode } = useParams();
    const { slug } = useParams();
    const code = propCode || urlCode;
    const initial = localStorage.getItem('initials');
    const fullname = localStorage.getItem('name');
    const profileColor = localStorage.getItem('profileColor');
    const allocatedTeam = localStorage.getItem('allocatedTeam');
    const allocatedTeamColor = localStorage.getItem('allocatedTeamColor');
    const [animate, setAnimate] = useState(false); // Add animate state
    const [participants, setParticipants] = useState([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [currentScore, setCurrentScore] = useState(0);
    const [guessedLetters, setGuessedLetters] = useState([]); // State for guessed letters
    const [correctWord, setCorrectWord] = useState(""); // Store correct word from DB
    const [currentLanguage, setCurrentLanguage] = useState('en'); // State for current language
    const [alphabet, setAlphabet] = useState(getAlphabetForLanguage('en')); // State for alphabet

    // Update language and alphabet when correctWord changes
    useEffect(() => {
        const detectedLanguage = correctWord && correctWord.trim() ? detectLanguageFromWord(correctWord) : 'en';
        setCurrentLanguage(detectedLanguage);
        setAlphabet(getAlphabetForLanguage(detectedLanguage));
        console.log('Language detected for word:', correctWord, '-> Language:', detectedLanguage, '-> Alphabet length:', getAlphabetForLanguage(detectedLanguage).length);
    }, [correctWord]);
    const [participantsStartedAnswering, setParticipantsStartedAnswering] =
        useState(false);
    const noSleep = new NoSleep();

    useEffect(() => {
        if (code) {

            handleFirebaseUpdatebycode();
        } else {
            handleFirebaseUpdatebyslug();
        }
    }, [code, fullname]);

    // handleExit for when Firebase command 7020 is received from host
    const handleExit = () => {
        console.log("exitgame: 7020 command received, exiting participant");
        const keysToRemove = [
            'wordToGuess', 'guessedLetters', 'wrongGuesses', 'currentTeam', 'score',
            'currentScreen', 'roundWinners', 'selectedRound', 'startTime', 'allocatedTeam',
            'allocatedTeamColor', 'currentScreenParticipantside', 'initials', 'name', 'profileColor', 'code'
        ];
        keysToRemove.forEach((key) => window.localStorage.removeItem(key));

        const isIOSNative = !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeProcess);
        
        if (isIOSNative) {
            try {
                window.webkit.messageHandlers.nativeProcess.postMessage("ExitGame");
            } catch (e) {}
        } else {
            setTimeout(() => {
                window.location.href = 'https://play.triviamaker.com/';
            }, 100);
        }
    };

    // window.exitgame is set by parent App.js component - no need to set it here

    const handleFirebaseUpdatebycode = () => {
        const db = firebase.database();
        const ref = db.ref(`AppleTV/${code}`);
        let previousData;
        ref.on("value", (snapshot) => {
            const data = snapshot.val();
            if (data !== previousData) {
                console.log("Data updated (handleFirebaseUpdatebycode):", data);
                previousData = data;

                const teamParticipants = data !== null && 'teamNames' in data ? data.teamNames.map((team) => ({
                    initials: team.initials,
                    name: team.name,
                    profileColor: team.profileColor,
                })) : [];

                setParticipants(teamParticipants);

                if (data.command === '7010') {
                    console.log("Navigating to PlayerWinnerParticipant");
                    onNavigate('PlayerWinnerParticipant'); // Navigate to PlayerWinnerParticipant
                }
                if (data.command === '7020') {
                    handleExit();
                }


                if (data.command === '7300') {
                    setIsButtonDisabled(true);
                    onNavigate('LeaderBoard');
                }

                if (data.command === '7320') {
                    console.log("7320 called");
                    onNavigate('LeaderBoard');

                }

                // Store correct word in state
                if (data.correctWord) {
                    setCorrectWord(data.correctWord.toUpperCase());
                }

                // Fetch scores from database
                const scores = data.scores;
                if (scores) {
                    const participantName = fullname;
                    const participantScore = scores[participantName];
                    if (participantScore) {
                        setCurrentScore(participantScore.score);
                    }
                }


                // Update guessed letters from the database
                if (data.guessedWord) {
                    const guessed = Array.isArray(data.guessedWord) ? data.guessedWord : []; // Ensure it's an array
                    setGuessedLetters(guessed);
                }
            }
        });
    }
    const handleFirebaseUpdatebyslug = () => {
        const db = firebase.database();
        const ref = db.ref(`AppleTV/${slug}`);
        let previousData;
        ref.on("value", (snapshot) => {
            const data = snapshot.val();
            if (data !== previousData) {
                console.log("Data updated (handleFirebaseUpdatebyslug):", data);
                previousData = data;

                const teamParticipants = data !== null && 'teamNames' in data ? data.teamNames.map((team) => ({
                    initials: team.initials,
                    name: team.name,
                    profileColor: team.profileColor,
                })) : [];

                setParticipants(teamParticipants);

                if (data.command === '7010') {
                    console.log("Navigating to PlayerWinnerParticipant");
                    onNavigate('PlayerWinnerParticipant'); // Navigate to PlayerWinnerParticipant
                }
                if (data.command === '7020') {
                    handleExit();
                }

                if (data.command === '7300') {
                    setIsButtonDisabled(true);
                    onNavigate('LeaderBoard');
                }

                if (data.command === '7320') {
                    console.log("7320 called");
                    onNavigate('LeaderBoard');

                }

                // Store correct word in state
                if (data.correctWord) {
                    setCorrectWord(data.correctWord.toUpperCase());
                }

                // Fetch scores from database
                const scores = data.scores;
                if (scores) {
                    const participantName = fullname;
                    const participantScore = scores[participantName];
                    if (participantScore) {
                        setCurrentScore(participantScore.score);
                    }
                }


                // Update guessed letters from the database
                if (data.guessedWord) {
                    const guessed = Array.isArray(data.guessedWord) ? data.guessedWord : []; // Ensure it's an array
                    setGuessedLetters(guessed);
                }
            }
        });
    }

    // const handleAlphabetClick = async (letter) => {
    //     setIsButtonDisabled(true);  // Disable the button to prevent multiple clicks
    //     const db = firebase.database();
    //     const ref = db.ref(`AppleTV/${code}/guessedWordbyparticipant`);

    //     try {
    //         // Use Firebase transaction to handle simultaneous clicks safely
    //         ref.transaction((currentGuessedWord) => {
    //             if (currentGuessedWord === null) {
    //                 currentGuessedWord = [];  // Initialize if it's null
    //             }
    //             // Check if the letter has already been guessed
    //             const alreadyGuessed = currentGuessedWord.some(
    //                 (guess) => guess.name === fullname && guess.guessedword === letter
    //             );

    //             // If the letter hasn't been guessed, add the new guess
    //             if (!alreadyGuessed) {
    //                 currentGuessedWord.push({
    //                     name: fullname,
    //                     guessedword: letter,
    //                 });
    //             }

    //             return currentGuessedWord;
    //         }).then(() => {
    //             console.log(`Guessed word "${letter}" sent successfully by ${fullname}`);

    //             // Check if guessed word is correct and trigger animation
    //             if (correctWord.includes(letter)) {
    //                 setAnimate(true); // Trigger animation
    //             } else {
    //                 setAnimate(false); // Reset animation if incorrect
    //             }

    //         }).catch((error) => {
    //             console.error('Error sending guessed word:', error);
    //         });

    //     } catch (error) {
    //         console.error('Error in handleAlphabetClick:', error);
    //     }
    // };

    const handleAlphabetClick = async (letter) => {
        setIsButtonDisabled(true); // Disable the button to prevent multiple clicks

        // Get the current URL path
        const currentPath = window.location.pathname;

        // Declare and initialize `code`
        // let code;
        // const pathSegments = currentPath.split('/');
        // if (currentPath.includes('/student')) {
        //     // If the URL includes '/student', use the last segment as the slug
        //     code = pathSegments[pathSegments.length - 1];
        // } else if (currentPath.includes('/h/')) {
        //     // If the URL includes '/h/', extract the code after '/h/'
        //     const match = currentPath.match(/\/h\/(\d+)/);
        //     code = match ? match[1] : 'defaultCode'; // Use the captured number or fallback to default
        // } else {
        //     code = 'defaultCode'; // Fallback value if no condition matches
        // }

        // Initialize Firebase reference
        const db = firebase.database();
        const ref = db.ref(`AppleTV/${code}/guessedWordbyparticipant`);

        try {
            // Use Firebase transaction to handle simultaneous clicks safely
            ref.transaction((currentGuessedWord) => {
                if (currentGuessedWord === null) {
                    currentGuessedWord = []; // Initialize if it's null
                }
                // Check if the letter has already been guessed
                const alreadyGuessed = currentGuessedWord.some(
                    (guess) => guess.name === fullname && guess.guessedword === letter
                );

                // If the letter hasn't been guessed, add the new guess
                if (!alreadyGuessed) {
                    currentGuessedWord.push({
                        name: fullname,
                        guessedword: letter,
                    });
                }

                return currentGuessedWord;
            }).then(() => {
                console.log(`Guessed word "${letter}" sent successfully by ${fullname}`);

                // Check if guessed word is correct and trigger animation
                if (correctWord.includes(letter)) {
                    setAnimate(true); // Trigger animation
                } else {
                    setAnimate(false); // Reset animation if incorrect
                }

            }).catch((error) => {
                console.error('Error sending guessed word:', error);
            });

        } catch (error) {
            console.error('Error in handleAlphabetClick:', error);
        }
    };


    return (
        <>
            <div className="leaderboardMainparticipant">
                <div className="Teamassigned row" style={{ background: allocatedTeamColor }}>
                    <span className="teamnameassignid">You are on {allocatedTeam} - It's your turn!</span>
                </div>
                <div id="commonplayersscorboard" className="common-players-scoreboard row">
                    <div className="centered-content" style={{ display: 'none' }}>
                        <span id="commmand">0</span>
                    </div>
                    <div className="col-xl-4 col-lg-3 col-md-1 col-sm-1 col-xs-0"></div>
                    <div className="col-xl-4 col-lg-6 col-md-10 col-sm-10 col-xs-12 padding-fix">
                        <div className="score-container">
                            <div className="topscorebarclass" id="topscorebar">
                                <div className="initial-letter-container">
                                    <span id="commominitialletterid" className="animallistcircle initial-letter" style={{ background: profileColor }}>{initial}</span>
                                </div>
                                <div className="teamtitle ellipsis-text">
                                    <span id="commonusernameid">{fullname}</span>
                                </div>
                                <div id="commontrophydivid" className="trophy-container">
                                    <img id="winningtrophtimgid" src=" " alt="Trophy" style={{ display: 'none' }} />
                                    <span id="userrankid" className="animallistcircle rank-circle" style={{ display: 'none' }}>--</span>
                                </div>
                                <div className="score-title-container">
                                    <span className="scortextspanclass" id="topbarscoretitle">Score</span>
                                </div>
                                {/* Conditionally apply animation classes if animate is true */}
                                <div id="scorebox" className={`scorebox ${animate ? 'animate-contain' : ''}`}>
                                    <div className={`score-display ${animate ? 'animated-text' : ''}`}>
                                        <span id="currentscoreidforplayScreen" className={` ${animate ? 'currentscoreidanimate' : ''}`}>{currentScore}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-3 col-md-1 col-sm-1 col-xs-0"></div>
                </div>

                <div className="row top">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 leaderboard-container">
                        <div className="leaderboardwidth">
                            <div className="leaderboardblackboard">
                                <div className="colorleaderboard">
                                    <div className="leaderboard-text">
                                        <span id="leaderboardtext">Which alphabet should your team<br />pick?<br /><br />Place your vote</span>
                                    </div>
                                </div>
                            </div>
                            <div className="keyboard">
                                {alphabet.map((letter, index) => (
                                    <button
                                        key={index}
                                        className={`alphabet-button-participant ${currentLanguage === 'ar' ? 'arabic' : ''}`}
                                        disabled={guessedLetters.includes(letter) || isButtonDisabled}
                                        onClick={(e) => {
                                            e.target.style.backgroundColor = '#808080';
                                            handleAlphabetClick(letter);
                                        }}
                                        style={{
                                            backgroundColor: guessedLetters.includes(letter) ? 'white' : '',
                                            color: guessedLetters.includes(letter) ? 'black' : '',
                                        }}
                                    >
                                        {letter}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
